module.exports = __webpack_public_path__ + "static/img/b20.6e73d44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b20.jpg
// module id = rhvv
// module chunks = 1